import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, NgZone } from '@angular/core';
import { IKeyValueInterface, BookingStatus } from './../../shared/config';
import { Router } from "@angular/router";
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL } from '../../shared/config';
import { SignupOverviewList } from "../models/signup-list.model";
import { SignupListService } from "../models/signup-list.service";


const moment = require("moment");

@Component({
  selector: 'confirm-signup-popup',
  template: require('../views/confirm-signup-popup.component.html'),
})

export class ConfirmSignupPopupComponent implements OnInit {
  apiErrorMsg: any;
  _model: SignupOverviewList;


  public isLoading: boolean;
  public headers: any;
  public errorModel: IKeyValueInterface[];
  public errorMsg: string;

  public contractTypeGroupList: any;


  @ViewChild('approvalSignupModel') public approvalSignupModel: any;

  @Output('OnSuccessSave') onSuccessSave = new EventEmitter();

  constructor(private authService: AuthService
    , private router: Router
    , private translate: TranslateService
    , private zone: NgZone
    , private signupListService: SignupListService) {

  }

  @Input()
  set model(_signupOverviewList: SignupOverviewList) {
    this._model = _signupOverviewList;
  }
  get model() { return this._model; }

  ngOnInit() {
  }

  public show(): void {
    this.errorMsg = '';
    this.errorModel = [];
    this.approvalSignupModel.show();
  }

  public hide(): void {
    this.model = new SignupOverviewList();
    this.approvalSignupModel.hide();
  }

  private OnSuccessSave() {
    this.hide();
    let successMsg = this.translate.instant('LblSuccess');
    this.onSuccessSave.emit({ SuccessMessage: successMsg })
  }

  public OnSubmit() {
    this.isLoading = true;
    this.signupListService.AcceptRejectSignup(this.model, true, false).subscribe(
      res => {
        this.isLoading = false;       
        this.OnSuccessSave()
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnReject() {
    this.isLoading = true;
    this.signupListService.AcceptRejectSignup(this.model, false, true).subscribe(
      res => {
        this.isLoading = false;
        this.OnSuccessSave()
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signupform/components/confirm-signup-popup.component.ts